<section class="main-section usercenter-section p-3">
  <header *ngIf="!hideHeader && userRole?.includes(roles.MatAdmin)" class="d-block d-md-flex justify-content-between align-items-center main-heading">
    <div class="row align-items-center w-100">
      <div class="d-flex align-items-center col-md-7" *ngIf="!userRole?.includes(roles.MatAdmin)">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
          role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          </svg></a>
        <h3 class="heading-span visited-heading-span cursor-pointer"
          [ngClass]="clientAccountName || schoolName ? 'underline': ''" (click)="goBack()"> {{ openedFromIndependentSchool
          ? 'Individual School' : '..User Centre' }} </h3>
        <h3 *ngIf="clientAccountName" [ngClass]="schoolName ? 'visited-heading-span cursor-pointer underline': ''"
          class="heading-span mat-account-detail w-auto" (click)="schoolName=''; hideCreate=false"
          [matTooltip]="clientAccountName"> / {{ clientAccountName }}</h3>
        <h3 *ngIf="openedFromIndependentSchool" class="heading-span mat-account-detail" [matTooltip]="schoolName"> / {{schoolName}} </h3>
      </div>
      <div [ngClass]="{
        'col-md-12': userRole.includes(roles.MatAdmin) || userRole.includes(roles.SchoolAdmin),
        'col-md-5': !userRole.includes(roles.MatAdmin) && !userRole.includes(roles.SchoolAdmin)
      }" class="d-flex pe-0" [ngClass]="{'justify-content-between' : userRole.length && userRole.includes(roles.MatAdmin),
    'justify-content-end' : userRole.length && !userRole.includes(roles.MatAdmin)}">
        <div class="col-md-3 my-auto" *ngIf="userRole?.includes(roles.MatAdmin)">
          <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
            role="button" aria-controls="offcanvasExample">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            </svg></a>
          <h3 *ngIf="userRole?.includes(roles.MatAdmin)" class="heading-span"> <span>Admin Details</span></h3>
        </div>
        <div class="d-flex">
          <div class="input-group me-2 user-center-search mt-2 mt-md-0">
            <span class="input-group-text bg-transparent" id="basic-addon1" 
            (click)="onSearch()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                  stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <input type="text" class="form-control usercenter-searchcontrol ps-0 bg-white" placeholder="Search"
              aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchTerm"
              (keyup.enter)="onSearch()" />
          </div>
          <mat-icon matTooltip="Search by First Name / Last Name / Email Address / Country Code"
            class="fs-22 m-2">info</mat-icon>
        </div>
        <div *ngIf="showCreate()" class="col-md-2 text-end">
          <button type="button" class="btn theme-btn" (click)="onCreate()">
            <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg></span>
            <span class="d-none d-sm-block">{{ createText }}</span>
          </button>
        </div>
      </div>
    </div>
  </header>
  <header *ngIf="!hideHeader && !userRole?.includes(roles.MatAdmin)"
    class="d-block d-md-flex justify-content-between align-items-center main-heading">
    <div class="row align-items-center w-100">
      <div class="d-flex align-items-center col w-100 xcol-md-6">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
          role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          </svg></a>
        <h3 class="heading-span visited-heading-span cursor-pointer"
          [ngClass]="clientAccountName || schoolName ? 'underline': ''" (click)="goBack()"> {{
          openedFromIndependentSchool ? 'Individual School' : 'User Centre' }} </h3>
        <h3 *ngIf="clientAccountName" [ngClass]="schoolName ? 'visited-heading-span cursor-pointer underline': ''"
          class="heading-span mat-account-detail w-auto" (click)="schoolName=''; hideCreate=false"
          [matTooltip]="clientAccountName"> / {{ clientAccountName }}</h3>
        <h3 *ngIf="this.openedFromIndependentSchool" class="heading-span xmat-account-detail" [matTooltip]="schoolName"> / {{schoolName}} </h3>
      </div>
      <div class="d-flex col xcol-md-6 justify-content-end">
        <div
          *ngIf="(activeTab == tabs.AdminDetails) || (this.activeTab == tabs.Schools && this.hideCreate) || this.activeTab == tabs.Users"
          class="d-flex">
          <div class="input-group me-2 user-center-search mt-2 mt-md-0">
            <span class="input-group-text bg-transparent" id="basic-addon1" (click)="onSearch()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                  stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <input type="text" class="form-control usercenter-searchcontrol ps-0 bg-white" placeholder="Search"
              aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchTerm"
              (keyup.enter)="onSearch()" />
          </div>
          <mat-icon matTooltip="Search by First Name / Last Name / Email Address / Country Code"
            class="fs-22 m-2">info</mat-icon>
        </div>
        <div *ngIf="showCreate()" class="">
          <button type="button" class="btn theme-btn" (click)="onCreate()">
            <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg></span>
            <span class="d-none d-sm-block">{{ createText }}</span>
          </button>
        </div>
      </div>
    </div>
  </header>
  <div *ngIf="!hideHeader && !userRole?.includes(roles.MatAdmin)"
    class="bg-white d-flex w-100 align-items-center radius8 mb-3 py-2">
    <div class="tabs mb-0 col-md-6">
      <ul class="nav nav-tabs mobile-view-tablist">
        
        <li *ngIf="openedFromIndependentSchool" class="nav-item">
          <button (click)="setActiveTab(tabs.Users)" [ngClass]="activeTab == tabs.Users ? 'active' : ''"
            class="nav-link" id="inactive-user-tab" data-bs-toggle="tab" data-bs-target="#inactive-user-tab-pane"
            type="button" role="tab" aria-controls="inactive-user-tab-pane" aria-selected="false">
            <span>Users</span>
          </button>
        </li>

        
         <li *ngIf="!openedFromIndependentSchool" class="nav-item">
          <button (click)="setActiveTab(tabs.Schools)" [ngClass]="activeTab == tabs.Schools ? 'active' : ''"
            class="nav-link" id="inactive-user-tab" data-bs-toggle="tab" data-bs-target="#inactive-user-tab-pane"
            type="button" role="tab" aria-controls="inactive-user-tab-pane" aria-selected="true">
            <span>{{schoolName?'Selected School':'Schools'}}</span>
          </button>
        </li>
        
        <li class="nav-item">
          <button (click)="setActiveTab(tabs.Role)" [ngClass]="activeTab == tabs.Role ? 'active' : ''" class="nav-link"
            id="inactive-user-tab" data-bs-toggle="tab" data-bs-target="#inactive-user-tab-pane" type="button"
            role="tab" aria-controls="inactive-user-tab-pane" aria-selected="false">
            <span>Audiences</span>
          </button>
        </li>
       
        <li *ngIf="!openedFromIndependentSchool" class="nav-item">
          <button (click)="setActiveTab(tabs.AdminDetails)" [ngClass]="activeTab == tabs.AdminDetails ? 'active' : ''"
            class="nav-link" id="active-user-tab" data-bs-toggle="tab" data-bs-target="#active-user-tab-pane"
            type="button" role="tab" aria-controls="active-user-tab-pane" aria-selected="false">
            <span>Admin Details</span>
          </button>
        </li>
        <li class="nav-item">
          <button (click)="setActiveTab(tabs.Package)" [ngClass]="activeTab == tabs.Package ? 'active' : ''"
            class="nav-link" id="active-user-tab" data-bs-toggle="tab" data-bs-target="#active-user-tab-pane"
            type="button" role="tab" aria-controls="active-user-tab-pane" aria-selected="false">
            <span>Package</span>
          </button>
        </li>


      </ul>
    </div>
    <div class="col-md-6 justify-content-end d-flex">
      <button *ngIf="activeTab == tabs.Schools || openedFromIndependentSchool" type="button" class="btn theme-btn me-4"
        (click)="onTransferSchool()">Transfer School</button>
      <div *ngIf="(userRole?.includes(roles.SuperAdmin) || userRole?.includes(roles.AccountAdmin)) &&
                 activeTab == tabs.Package" class="">
        <button type="button" class="btn theme-btn-outline me-4" (click)="onChangePackage()"
          [disabled]="openedFromType == 7">Change Package</button>
      </div>
    </div>
  </div>
  <div class="tab-content" id="myTabContent">
    <div *ngIf="activeTab == tabs.AdminDetails"
      [ngClass]="activeTab == tabs.AdminDetails ? 'tab-pane fade show active' : 'tab-pane fade'" id="module"
      role="tabpanel" aria-labelledby="Module">
      <div class="table-responsive user-center-table mb-0 px-3 pt-0 pb-3 mx-0"
        [ngClass]="{'mat-admin-details-table' : userRole.length && userRole.includes(roles.MatAdmin)}">
        <table *ngIf="matAdminList?.length" aria-describedby="This table describes the mat admin information"
          class="table table-hover">
          <thead>
            <tr>
              <th>S.No</th>
              <th class="firstName-header">First Name
                <span>
                  <mat-icon *ngIf="sortFirstNameAsc"
                    (click)="sortFirstNameAsc=false;getClientAdminDetails('firstName','asc')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!sortFirstNameAsc"
                    (click)="sortFirstNameAsc=true;getClientAdminDetails('firstName','desc')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="lastName-header">Last Name
                <span>
                  <mat-icon *ngIf="sortLastNameAsc"
                    (click)="sortLastNameAsc=false;getClientAdminDetails('lastName','asc')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!sortLastNameAsc"
                    (click)="sortLastNameAsc=true;getClientAdminDetails('lastName','desc')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="contactNumber-header">Email Address
                <span>
                  <mat-icon *ngIf="sortEmailIdAsc"
                    (click)="sortEmailIdAsc=false;getClientAdminDetails('emailId','asc')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!sortEmailIdAsc"
                    (click)="sortEmailIdAsc=true;getClientAdminDetails('emailId','desc')">arrow_downward</mat-icon>
                </span>
              </th>
              <th>Country Code
                <span>
                  <mat-icon *ngIf="sortCountryCodeAsc"
                    (click)="sortCountryCodeAsc=false;getClientAdminDetails('countryCode','asc')">arrow_upward</mat-icon>
                  <mat-icon *ngIf="!sortCountryCodeAsc"
                    (click)="sortCountryCodeAsc=true;getClientAdminDetails('countryCode','desc')">arrow_downward</mat-icon>
                </span>
              </th>
              <th class="contactNumber-header">Contact Number</th>
              <th class="contactNumber-header">Document</th>
              <th class="action-header sticky-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let matAdmin of matAdminList; let i = index">
              <td>{{ i + 1 }}</td>
              <td matTooltip="{{ matAdmin.firstName }}">
                <p #matAccountDetail class="mat-account-detail mb-0">{{ matAdmin.firstName }}</p>
              </td>
              <td matTooltip="{{ matAdmin.lastName }}">
                <p #matAccountDetail class="mat-account-detail mb-0">{{ matAdmin.lastName }}</p>
              </td>
              <td matTooltip="{{ matAdmin.emailId }}">
                <div class="mat-account-detail mb-0 badge-progress" [class.badge-new]="matAdmin.isAccountActivated!==true && matAdmin.isActive===true"
                  [class.badge-in-progress]="matAdmin.isAccountActivated!==true && matAdmin.isActive!==true"
                  [class.badge-on-hold]="matAdmin.isAccountActivated===true && matAdmin.isActive!==true"><a #matAccountDetail class="mat-account-detail mb-0"  href="mailto:{{matAdmin.emailId}}">
                {{matAdmin.emailId}}
              </a></div>
              </td>
              <td>{{ matAdmin.countryCode }}</td>
              <td>{{ matAdmin.phoneNumber }}</td>
              <td>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="
                    $event.preventDefault();
                    $event.stopPropagation();
                    ViewDocument(matAdmin)
                  ">
                  <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#5D847B"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#5D847B" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7 13H13" stroke="#5D847B" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7 17H11" stroke="#5D847B" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </td>
              <td class="sticky-right">
                <a class="btn-action" (click)="openEditModal(matAdmin)" matTooltip="Edit details">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                      stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004" stroke="#4F6681"
                      stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 18.3334H17.5" stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
                <a class="btn-action" (click)="deleteMatAdmin(matAdmin)" matTooltip="Delete details">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                      fill="#4F6681" />
                  </svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-paginator *ngIf="matAdminList?.length" [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageNumber"
        (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
      </mat-paginator>
      <div *ngIf="!matAdminList?.length" class="noDataFound">
        <h1>{{'No Data Found'}}</h1>
      </div>
    </div>
    <div *ngIf="activeTab == tabs.Schools"
      [ngClass]="activeTab == tabs.Schools ? 'tab-pane fade show active' : 'tab-pane fade'" id="module" role="tabpanel"
      aria-labelledby="Module">
      <h4 *ngIf="schoolName" class="theme-card-text" style="padding:12px;padding-left:24px">{{schoolName}}</h4>
      <app-school-details (hideCreateButton)="hideCreate=$event" (hideHeaderOnCreateSchool)="showSchoolDetails($event)"
        [createTriggered]="createTriggered" [assignedPackageId]="assignedPackageId" [searchTriggered]="searchTriggered"
        [searchTerm]="searchTerm" [isCurrentTab]="activeTab" [clientAccountId]="clientAccountId"
        (resetCreateTrigger)="createTriggered = false; searchTriggered = false;" [goBack]="schoolName ? 0 : 1"
        (showSchoolUserList)="updateTitle($event)">
      </app-school-details>
    </div>
    <div *ngIf="activeTab == tabs.Package"
      [ngClass]="activeTab == tabs.Package ? 'tab-pane fade show active' : 'tab-pane fade'" id="subCategory"
      role="tabpanel" aria-labelledby="SubCategory">
      <app-package-details [openedFromMatAccountpreview]="true" [assignedPackageId]="assignedPackageId"
        [searchTriggered]="searchTriggered" [searchTerm]="searchTerm" [createTriggered]="createTriggered"
        (resetCreateTrigger)="createTriggered = false; openedFromType = 6" [openedFromType]="openedFromType"
        [clientAccountId]="clientAccountId" [schoolId]="schoolId">
      </app-package-details>
    </div>
    <div *ngIf="activeTab == tabs.Role"
      [ngClass]="activeTab == tabs.Role ? 'tab-pane fade show active' : 'tab-pane fade'" id="metric" role="tabpanel"
      aria-labelledby="Metric">
      <app-user-role [packageId]="assignedPackageId" [searchTriggered]="searchTriggered" [searchTerm]="searchTerm"
        [isCurrentTab]="activeTab" [createTriggered]="createTriggered" [clientAccountId]="clientAccountId"
        [schoolId]="schoolId" (resetCreateTrigger)="createTriggered = false">
      </app-user-role>
    </div>
    <div *ngIf="activeTab == tabs.Users"
      [ngClass]="activeTab == tabs.Users ? 'tab-pane fade show active' : 'tab-pane fade'" id="metric" role="tabpanel"
      aria-labelledby="Metric">
      <app-user-details (resetCreateTrigger)="createTriggered = false" [viewMode]="true"
        [createTriggered]="createTriggered" [openedFromIndividualSchool]="true" [schoolId]="schoolId"
        [packageId]="assignedPackageId" [roles]="roleData" [showSchoolUser]="true"
        [numberOfUsersToAllow]="numberOfUsersToAllow" [clientAccountId]="clientAccountId"
        [searchTriggered]="searchTriggered" [searchTerm]="searchTerm">
      </app-user-details>
    </div>
  </div>
</section>